import { PbxNumbersEdit } from "./pbx_numbers_edit";

export class PBXNumbers extends HTMLElement {
  constructor(group_id, domain_id) {
    super();
    this.group_id = group_id;
    this.domain_id = domain_id;
  }

  connectedCallback() {
    this.innerHTML =
      `
      <div class="pbx_table_main">
        <div class="row">
          <div class="col-sm-12">
            <h3>Phone Numbers</h3>
            <span>Manage and create phone numbers for your system.</span>
            <button id="pbx_add_number" class="btn btn-primary pull-right" data-cy="pbx_add_extension">Add Number</button>
          </div>
        </div>
        <table id="pbx_number_table" class="table" style="width:100%; display:table;">
            <thead>
                <tr>
                  <!--th><input name="select_all" value="1" type="checkbox"></th-->
                  <th>Name</th>
                  <th>Phone Number</th>
                  <th>Action</th>
                </tr>
            </thead>
        </table>
      </div>
      `;
    this.init();
    this.querySelector('#pbx_add_number').addEventListener('click', function() {
      this.hide();
      this.appendChild(new PBXAddNumber(this.group_id, this.domain_id, this.show.bind(this), this.reloadTable.bind(this)))
    }.bind(this))

    // Edit individual Number
    $('#pbx_number_table tbody').on('click', 'a.number_edit_link', function(e) {
      let tr  = $(e.target).closest('tr')
      this.hide()
      let editPage = new PbxNumbersEdit(this.group_id, this.domain_id, this.show.bind(this), this.reloadTable.bind(this), this.table.row(tr).data());
      this.appendChild(editPage)
    }.bind(this))
  }

  init() {
    let is_admin = this.is_admin;
    this.table = $('#pbx_number_table').DataTable({
      "dom": '<f<t>lip>',
      "ajax": `/admin/groups/${this.group_id}/pbx/dids`,
      "rowId": '',
      "columns": [
        {
          data: "campaign_name"
        },
        { data : "did", "searchable":true, "orderable":true, "className": 'dt-center',
          "render": function ( data, type, row ) {
            return data != null ? data.toString().replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : "";
        }},
        {
          "render": function(data, type, row) {
            return `</span><a class="number_edit_link">Edit&nbsp</a>${is_admin ? `&nbsp|&nbsp <a class="number_delete_link">Delete</a>` : ``}`;
          },
          "class": "text-center"
        }
      ],
      "order": [[0, 'asc']]
    });
  }

  show() {
    this.querySelector('.pbx_table_main').classList.remove('hidden');
  }

  hide() {
    this.querySelector('.pbx_table_main').classList.add('hidden');
  }

  reloadTable() {
    this.table.ajax.reload();
  }
}

customElements.define('pbx-numbers', PBXNumbers)

export class PBXAddNumber extends HTMLElement {
  constructor(group_id, domain_id, showList, reloadTable) {
    super();
    this.group_id = group_id;
    this.domain_id = domain_id;
    this.showList = showList;
    this.reloadTable = reloadTable;
  }

  async connectedCallback() {
    this.innerHTML =
      `
      <style>
        pbx-add-number input,
        pbx-add-number select {
          margin-bottom: 20px;
        }
      </style>
      <div class="row pbx_number_form">
        <div class="col-sm-12 no-gutters">
          <h3><span id="pbx_number_back"></span> Create Number</h3>
        </div>
        <div class="errors"></div>
        <div class="col-sm-7">
          <div class="number_name_options">
            <label>Name</label>
            <input class="form-control number_new_name" placeholder="Name">
            <label>Call Treatment</label>
            <select is=treatments-select class="form-control call_treatments_id" data-cy="call-treat-id" domain_id="${this.domain_id}"></select>
          </div>
        </div>

        <div class="col-sm-7">
          <label>Select local or toll free number</label>
        </div>
        <pbx-number-picker data-required="true"></pbx-number-picker>

        <div class="form-group col-sm-7 no-gutters" style="overflow:auto;">
          <a id="add_number_save" class='btn btn-primary pull-right detail-row-button'>Save</a>
          <a id="add_number_cancel" class='btn btn-outline-secondary pull-right detail-row-button'>Close</a>
        </div>
      </div>
      `;

    this.querySelectorAll('#add_number_cancel, #pbx_number_back').forEach(e => {
      e.addEventListener('click', function() {
        this.hide();
      }.bind(this))
    })

    //this.querySelector('.number_names').onchange = (e) => {this.handleName(e.target.value)}

    this.querySelector('#add_number_save').addEventListener('click', function() {
      this.save();
    }.bind(this))
  }

  hide(){
    this.showList();
    this.remove();
  }

  validate() {
    let isValid = true;
    let errors = '';
    this.querySelector('.errors').innerHTML = '';
    this.querySelectorAll('.error').forEach(e => {
      e.classList.remove('error');
    })
    let validateNumber = this.querySelector('pbx-number-picker').validate();

    if(!this.querySelector('.number_new_name').value) {
      this.querySelector('.number_new_name').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please provide a name.
                                                </div>`;

      isValid = false;
    }
    if(!this.querySelector('.call_treatments_id').value) {
      this.querySelector('.call_treatments_id').classList.add('error');
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a call treatment.
                                                </div>`;

      isValid = false;
    }
    if(!validateNumber.isValid) {
      if(validateNumber.type == 'none') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select number type.
                                                </div>`;
      } else if (validateNumber.type == 'toll-free') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a toll free prefix.
                                                </div>`;
      } else if (validateNumber.type == 'local') {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                                                  <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                  <strong>Warning!</strong> Please select a local number prefix.
                                                </div>`;
      }
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;
    return isValid
  }

  async save() {
    if(!this.validate()) {
      return
    }
    let phone_number = this.querySelector('pbx-number-picker').getData();

    let data = {
      local_numbers: phone_number.local_numbers,
      npanxx: phone_number.npanxx
    }

    data.campaign_name = this.querySelector('.number_new_name').value;
    data.user_id = null;
    data.target_id = this.querySelector('.call_treatments_id').value;

    let res = await fetch(`/admin/groups/${this.group_id}/pbx/add_number`, {
      headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
      method: 'POST',
      body: JSON.stringify(data)
    });
    let response = await res.json();
    if(response.success) {
      Common.notify('New number created', 'success');
      this.reloadTable();
      document.querySelector('pbx-extensions').reloadTable();
      this.hide();
    } else {
      this.querySelector('.errors').innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
                                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                    <strong>Warning!</strong> Unable to create number. ${response.error ? response.error : ""}
                                                  </div>`
    }
  }
}

customElements.define('pbx-add-number', PBXAddNumber)